import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ace_text_controls form-inline"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 1,
  class: "checkbox ace_text_controls"
}
const _hoisted_4 = { for: "ace_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ace = _resolveComponent("ace")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.codeSyntaxSelectable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" Syntax Mode: ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modeInternal) = $event)),
              class: "form-control"
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("option", { value: "-" }, "-None-", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aceModes, (mode) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: mode,
                  value: mode
                }, _toDisplayString(mode), 9, _hoisted_2))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.modeInternal]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.softWrapControl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            id: "ace_wrap",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wrapInternal) = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.wrapInternal]
          ]),
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("soft.wrap")), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ace, {
      modelValue: _ctx.valueInternal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valueInternal) = $event)),
      identifier: _ctx.identifier,
      lang: _ctx.modeInternal,
      "soft-wrap": _ctx.wrapInternal,
      theme: _ctx.theme,
      height: _ctx.height,
      width: _ctx.width,
      "min-lines": _ctx.minLines,
      "max-lines": _ctx.maxLines,
      onInit: _ctx.aceEditorInit
    }, null, 8, ["modelValue", "identifier", "lang", "soft-wrap", "theme", "height", "width", "min-lines", "max-lines", "onInit"])
  ]))
}